import {TitleCasePipe} from '@angular/common';
import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {MatMenuModule} from '@angular/material/menu';

@Component({
  selector: 'projects-task-dropdown-selector-button',
  standalone: true,
  imports: [MatMenuModule, TitleCasePipe, ReactiveFormsModule],
  templateUrl: './projects-task-dropdown-selector-button.component.html',
  styleUrl: './projects-task-dropdown-selector-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectsTaskDropdownSelectorButtonComponent {
  @Input() isSelected: boolean = false;
  @Input() dropdownOneOptions: string[] = [];
  @Input() dropdownTwoOptions: string[] = [];
  @Input() dropdownOneControl?: FormControl;
  @Input() dropdownTwoControl?: FormControl;
  @Input() newTask: boolean = false;

  @Output() buttonClick = new EventEmitter<void>();
  @Output() valueChange = new EventEmitter<{dropdownOne: string; dropdownTwo: string}>();

  onMainButtonClick() {
    this.buttonClick.emit();
  }

  onDropdown1Change(value: string) {
    if (this.dropdownOneControl) {
      this.dropdownOneControl.setValue(value);
    }
    this.valueChange.emit({dropdownOne: value, dropdownTwo: this.dropdownTwoControl?.value});
  }

  onDropdown2Change(value: string) {
    if (this.dropdownTwoControl) {
      this.dropdownTwoControl.setValue(value);
    }
    this.valueChange.emit({dropdownOne: this.dropdownOneControl?.value, dropdownTwo: value});
  }
}
